const registeredComponent = {
  xl: {
    NavBar: "desktop-nav-bar",
    Homepage: "desktop-homepage",
    Footer: "desktop-footer",
    ProductBrowse: "desktop-product-browse",
    ProductSearch: "desktop-product-search",
    AuthPortalSignIn: "desktop-signin",
    AuthPortalSignUp: "desktop-signup"
  },
  lg: {
    NavBar: "desktop-nav-bar",
    Homepage: "desktop-homepage",
    Footer: "desktop-footer",
    ProductBrowse: "desktop-product-browse",
    ProductSearch: "desktop-product-search",
    AuthPortalSignIn: "desktop-signin",
    AuthPortalSignUp: "desktop-signup"
  },
  md: {
    NavBar: "desktop-nav-bar",
    Homepage: "desktop-homepage",
    Footer: "desktop-footer",
    ProductBrowse: "desktop-product-browse",
    ProductSearch: "desktop-product-search",
    AuthPortalSignIn: "desktop-signin",
    AuthPortalSignUp: "desktop-signup"
  },
  sm: {
    NavBar: "mobile-nav-bar",
    Homepage: "mobile-homepage",
    Footer: "mobile-footer",
    ProductBrowse: "desktop-product-browse",
    ProductSearch: "desktop-product-search",
    AuthPortalSignIn: "mobile-signin",
    AuthPortalSignUp: "mobile-signup"
  },
  xs: {
    NavBar: "mobile-nav-bar",
    Homepage: "mobile-homepage",
    Footer: "mobile-footer",
    ProductBrowse: "mobile-product-browse",
    ProductSearch: "mobile-product-search",
    AuthPortalSignIn: "mobile-signin",
    AuthPortalSignUp: "mobile-signup"
  }
};

export default registeredComponent;
